angular.module('acme.view.application.importExport.importExportJob.directives.importExportJobMappings.importExportJobMappingsGrid', [
    'acme.common.service.utils',
    'acme.view.application.importExport.importExportJob.directives.importExportJobMappings.modals.change'
]).directive('importExportJobMappingsGrid', [function() {
    return {
        restrict: 'A',
        replace: true,
        scope: {
            job: '='
        },
        controller: 'importExportJobMappingsGridController',
        template: '<div><div data-ng-include="\'common/views/dataGrid/dataGrid.tpl.html\'" data-scope-property="importExportJobMappings" data-ng-controller="DataGridController"></div></div>'
    };
}]).controller( 'importExportJobMappingsGridController',  [
    '$rootScope',
    '$scope',
    '$state',
    '$timeout',
    '$uibModal',
    'PermissionsService',
    'UtilsService',
    'JOB_TYPE',
    'ImportJobsApiService',
    'GridStateFactory',
    'GridDefinitionFactory', function importExportJobMappingsGridController($rootScope, $scope, $state, $timeout, $uibModal, PermissionsService, UtilsService, JOB_TYPE, ImportJobsApiService, GridStateFactory, GridDefinitionFactory) {
    $scope.importExportJobMappings = {
        job: $scope.job,
        gridName: $state.current.name+'.grid.mappings',
        gridDefinition: new GridDefinitionFactory(),
        gridState: new GridStateFactory(),
        model: [],
        optionsOverride: {
            rowHeight: 30,
            data: 'importExportJobMappings.model',
            appScopeProvider: {
                onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
                    self.gridState.updateGridState(newPage, pageSize);
                    if (sortField) {
                        self.gridState.updateGridState(null, null, sortField, null);
                    }
                    if(sortDirection) {
                        self.gridState.updateGridState(null, null, null, sortDirection);
                    }
                    self.getMappings();
                },
                onDataGridSortChange: function(grid, columns, page) {
                    var data = columns[0];
                    self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
                    self.getMappings();
                },
                onDblClick: function (item) {
                },
                openMappingModal: function ($event, mode, mapping) {
                    if (!UtilsService.eventAlreadyFired($event)) {
                        $uibModal.open({
                            templateUrl: 'views/application/views/importExport/importExportJob/directives/importExportJobMappings/ImportExportJobMappingsModal.tpl.html',
                            controller: 'ImportExportJobMappingsModalController',
                            controllerAs: '$ctrl',
                            resolve: {
                                job: function () {
                                    return ImportJobsApiService.get(self.job.id)
                                        .then(function (response) {
                                            return response.data;
                                        });
                                },
                                mode: function () {
                                    return mode;
                                },
                                mappings: function () {
                                    return self.model;
                                },
                                mapping: function () {
                                    return mapping;
                                }
                            }
                        });
                    }
                }
            },
            columnDefs: [
                {
                    field: 'view',
                    displayName: 'View',
                    enableSorting: false,
                    width: 50,
                    cellTemplate:'<div class="clickable ui-grid-cell-contents" data-ng-class="col.colIndex()"><a role="button" data-ng-click="(grid.appScope ? grid.appScope : importExportJobMappings.optionsOverride.appScopeProvider).openMappingModal($event, \'view\', row.entity)">View <span class="sr-only">Mapping details in a modal</span></a></div>'
                },
                {
                    field: 'tableType',
                    width: 100,
                    displayName: 'Table Type'
                },
                {
                    field: 'fieldFrom',
                    displayName: 'From'
                },
                {
                    field: 'fieldTo',
                    width: 100,
                    displayName: 'To'
                }
            ]
        },

        init: function() {
            if (self.job.jobType === JOB_TYPE.EXPORT) {
                self.optionsOverride.columnDefs.push({
                    field: 'fieldExpression',
                    displayName: 'Expression'
                },
                {
                    field: 'sequence',
                    displayName: 'Sequence'
                });
            }
            // ENG-5828 removed edit/delete columns due to data truncate bug

            // if (PermissionsService.check('IMPEX_MAPPINGS_UPDATE')) {
            //     self.optionsOverride.columnDefs.push({
            //         field: 'edit',
            //         displayName: 'Edit',
            //         width: 50,
            //         enableSorting: false,
            //         cellTemplate: '<div class="clickable ui-grid-cell-contents" data-ng-class="col.colIndex()"><a role="button" data-ng-click="(grid.appScope ? grid.appScope : importExportJobMappings.optionsOverride.appScopeProvider).openMappingModal($event, \'edit\', row.entity)">Edit <span class="sr-only">Mapping details in a modal</span></a></div>'
            //     }, {
            //         field: 'delete',
            //         displayName: 'Delete',
            //         width: 50,
            //         enableSorting: false,
            //         cellTemplate: '<div class="clickable ui-grid-cell-contents" data-ng-class="col.colIndex()"><a role="button" data-ng-click="(grid.appScope ? grid.appScope : importExportJobMappings.optionsOverride.appScopeProvider).openMappingModal($event, \'delete\', row.entity)">Delete <span class="sr-only">Mapping details in a modal</span></a></div>'
            //     });
            // }

            self.gridDefinition.init(this.gridName, this.optionsOverride, $state.current.name, $state.current.data.enablePreferences);

            $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', this.initData));
        },

        initData: function(e, data) {
            var props = self.gridDefinition.getGridState();
            self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
            self.getMappings();
        },

        getMappings: function() {
            var gridState = self.gridState.getGridState();
            var sortField = null;
            if (gridState.sortField && gridState.sortDirection) {
                sortField = gridState.sortField + "," + gridState.sortDirection;
            }
            ImportJobsApiService.getMappingsWithPagination(self.job.id, gridState.page - 1,
                    gridState.pageSize,
                    sortField)
                .then(self.success.getData, self.error.getData);
        },

        success: {
            getData: function (response) {
                var data = response.data;
                self.model = data.content;

                self.gridDefinition.isLoaded = true;

                $timeout(function() {
                    $scope.$broadcast('DataGrid::ResizeGrid', {
                        name: self.gridName,
                        datasetLength: self.model.length,
                        totalItems: data.totalElements
                    });

                }, 10);
            }
        },

        error: {
            init: function(response) {},
            getData: function (data) {}
        }
    };

    var self = $scope.importExportJobMappings;
    self.init();
}]);
